export default "__VITE_ASSET__3090b36d__"